module.exports = __webpack_public_path__ + "media/images/posts/stones-6f9d0baffe9ef28ceed20e74f0cd71ad.jpg";